var map = {
	"./about/lighting.png": "e4ab",
	"./ac.png": "1b9e",
	"./blinds.png": "0cd5",
	"./device-location.png": "6b31",
	"./gamers.png": "e7a1",
	"./home-wifi.png": "0a8d",
	"./kids.png": "2b8e",
	"./lighting.png": "80ae",
	"./music.png": "dc44",
	"./party.png": "f896",
	"./remote-control.png": "150d",
	"./room-customization.png": "466b",
	"./special-needs.png": "b4ea",
	"./streaming-services.png": "7673",
	"./tech-bg.png": "1d21",
	"./voice.png": "9e56",
	"./wizard/theft_detection.png": "d00f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e078";